import React, { useState } from 'react';
import { Skill, SubSkill } from '../types';
import SkillTooltip from './SkillTooltip';

interface AboutProps {
  aboutParagraphs: string[];
  skills: Skill[];
}

const About: React.FC<AboutProps> = ({ aboutParagraphs, skills }) => {
  const [hoveredSkill, setHoveredSkill] = useState<SubSkill | null>(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const handleSkillHover = (event: React.MouseEvent, item: string | SubSkill) => {
    if (typeof item === 'object') {
      const rect = event.currentTarget.getBoundingClientRect();
      setTooltipPosition({
        x: rect.right + 10,
        y: rect.top
      });
      setHoveredSkill(item);
    }
  };

  const handleSkillLeave = () => {
    setHoveredSkill(null);
  };

  const isSubSkill = (item: string | SubSkill): item is SubSkill => {
    return typeof item === 'object';
  };

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-text">
            {aboutParagraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
          <div className="skills-grid">
            {skills.map((skill) => (
              <div key={skill.category} className="skill-card">
                <h3>{skill.category}</h3>
                <ul>
                  {skill.items.map((item, index) => (
                    <li
                      key={typeof item === 'string' ? item : item.name}
                      className={isSubSkill(item) ? 'skill-with-tooltip' : ''}
                      onMouseEnter={(e) => handleSkillHover(e, item)}
                      onMouseLeave={handleSkillLeave}
                    >
                      {typeof item === 'string' ? item : item.name}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="resume-section">
          <h3>Resume</h3>
          <a href="/resume.pdf" className="btn btn-primary" download>
            Download Resume (PDF)
          </a>
        </div>
      </div>
      {hoveredSkill && (
        <SkillTooltip
          subSkill={hoveredSkill}
          isVisible={!!hoveredSkill}
          position={tooltipPosition}
        />
      )}
    </section>
  );
};

export default About;
